import global$1 from './global.js';

var global = global$1;
var path = global;

export { path as default };
